import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import Price from 'Components/Utility/Price/Price';
import 'Features/Bundle/components/BundleRedesign/BundleRedesignTierBoxes.scss';
import { currencyCode } from 'Helpers/Geo/data';
import SelectedTierContext from 'Features/Bundle/context/selected-tier-context';
import SpecialFormattedNumber from 'Components/Utility/Price/SpecialFormattedNumber';
import BundleProductTypes from 'Helpers/Product/BundleProductTypes';

const BundleRedesignTierBoxes = ({
  bundleTiers = [],
}) => {
  const { selectedTier, selectTier } = useContext(SelectedTierContext);
  const onClick = (value) => {
    if (value !== selectedTier) {
      selectTier(value);
    }
  };

  const tierFullPrices = bundleTiers.reduce((acc, tier) => {
    const lastFullPrice = acc[acc.length - 1] || 0;
    const currentFullPrice = lastFullPrice + tier.fullPrice[`${currencyCode}`] / 100;
    return [...acc, currentFullPrice];
  }, []);

  const productTypes = BundleProductTypes(bundleTiers);

  return (
    <section className="BundleRedesignTierBoxes">
      {bundleTiers.map((tier, index) =>
        <button className={classNames('BundleRedesignTierBoxes__box', { 'BundleRedesignTierBoxes__box--selected': selectedTier === index })} key={tier._id} onClick={() => onClick(index)}>
          <div className="BundleRedesignTierBoxes__productCount">
            <FormattedMessage
              id="BundleRedesignTierBoxes.products"
              defaultMessage="{count} Products"
              values={{
                count: productTypes.tiersTotal[index].override ? productTypes.tiersTotal[index].override : productTypes.tiersTotal[index].all, // eslint-disable-line max-len
              }}
            />
            {((index + 1) === bundleTiers.length) && (bundleTiers.length > 1) &&
              <span className="BundleRedesignTierBoxes__bestValueLabel">
                <FormattedMessage
                  id="BundleRedesignTierBoxes.bestvalue"
                  defaultMessage="Best value"
                />
              </span>
            }
          </div>

          <div className="BundleRedesignTierBoxes__priceContainer">
            <div className="BundleRedesignTierBoxes__fullPrice">
              <SpecialFormattedNumber
                value={tierFullPrices[`${index}`]}
                style="currency"
              />
            </div>
            <div className={classNames('BundleRedesignTierBoxes__price', { 'BundleRedesignTierBoxes__price--selected': selectedTier === index })}>
              <Price price={tier.price} />
            </div>
          </div>
        </button>,
      )}
    </section>
  );
};

export default BundleRedesignTierBoxes;
